import { Language, languages } from '@/modules/language/constants';

export function useCurrentLanguage() {
  const availableLanguages = languages.filter((lang) => lang.display);

  return { availableLanguages, language: Language.en };
}
